import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              人气榜单
            </h2>
            <p className="text-sm text-foreground-500 mt-1.5">全网漫迷票选最受欢迎漫画实时排行</p>
          </div>
          <a
            href="#index"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex gap-4 bg-background-100 rounded-xl border border-background-200/70 p-4 cursor-pointer transition-all duration-200 hover:border-primary-200 hover:bg-background-50"
            >
              <div className="relative flex-shrink-0 w-[80px] h-[105px] rounded-lg overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className={`absolute top-0 left-0 w-6 h-6 flex items-center justify-center text-white text-xs font-heading font-bold rounded-br-lg ${
                  i === 0 ? 'bg-primary-500' : i === 1 ? 'bg-accent-500' : i === 2 ? 'bg-secondary-500' : 'bg-foreground-500'
                }`}>
                  {item.rank}
                </div>
              </div>

              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {item.title}
                    </h3>
                    <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-medium rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                    {item.desc}
                  </p>
                </div>
                <div className="flex items-center gap-1.5">
                  <i className="ri-fire-line text-xs text-primary-400" />
                  <span className="text-xs text-primary-500 font-medium">{item.heat}</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-6 sm:hidden">
          <a
            href="#index"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}